import { render, staticRenderFns } from "./subproperty-wallet.vue?vue&type=template&id=019751a9&"
import script from "./subproperty-wallet.vue?vue&type=script&lang=js&"
export * from "./subproperty-wallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports